<template>
    <div :key="iteration">
        <loading v-show="isLoading"></loading>

        <data-table
            :domain="domain"
            :title="title"
            :columns="columns"
            :colspan="colspan"
            :rows="rows"
            :limit="limit"
            :tables="tables"
            :footer="footer"
            :textAreas="textAreas"
            :classes="classes"
            :level="level"
            :heading="heading"
        />
    </div>
</template>

<script>

    import ApiWidget from './ApiWidget';
    import Loading from "./Loading.vue";
    import DataTable from "./DataTable.vue";

    export default {
        extends: ApiWidget,
        components: {DataTable, Loading},

        props: {
            domain: String
        },

        data() {
            return {
                title: {},
                columns: [],
                colspan: 1,
                rows: [],
                limit: null,
                tables: [],
                footer: '',
                level: 1,
                heading: 1,
            }
        },

        created() {
            this.registerParameterListeners([
                'company',
                'docType',
                'fund',
                'includeZero',
                'investor',
                'minRating',
                'modelRange',
                'portfolio',
                'range',
                'riskRated',
                'scheme',
                'searchString',
                'sector',
                'startDate',
                'endDate'
            ]);
        },

        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.title = this.retrieveTitle(data);
                this.columns = data.columns;
                this.colspan = data.columns.headings.length;
                this.rows = data.rows;

                if (data.limit_rows) {
                    this.limit = data.limit_rows;
                }

                this.tables = data.tables;
                this.footer = data.footer;
                this.textAreas = this.retrieveTextAreas(data);

                if (data.start_date) {
                    window.events.emit('setStartDate', data.start_date);
                }

                if (data.end_date) {
                    window.events.emit('setEndDate', data.end_date);
                }
            }
        }
    }

</script>
